function Footer () {
    return (
        <footer>
            <p>&#169; Copyright 2022 Matt Gainer Design by Matt Gainer</p>
        </footer>
    )
}

export default Footer;